var setPlayoutRect = function(playoutRect, videoHTMLContainer) {
    var currentStyle = videoHTMLContainer.style;
    var newStyle = {
        zIndex: playoutRect.zIndex ? "".concat(playoutRect.zIndex) : currentStyle.zIndex,
        left: !isNaN(playoutRect.x) ? "".concat(playoutRect.x, "px") : currentStyle.left,
        top: !isNaN(playoutRect.y) ? "".concat(playoutRect.y, "px") : currentStyle.top,
        width: !isNaN(playoutRect.width) ? "".concat(playoutRect.width, "px") : currentStyle.width,
        height: !isNaN(playoutRect.height) ? "".concat(playoutRect.height, "px") : currentStyle.height,
        backgroundColor: playoutRect.backgroundColor ? playoutRect.backgroundColor : currentStyle.backgroundColor
    };
    videoHTMLContainer.style.zIndex = newStyle.zIndex;
    videoHTMLContainer.style.left = newStyle.left;
    videoHTMLContainer.style.top = newStyle.top;
    videoHTMLContainer.style.width = newStyle.width;
    videoHTMLContainer.style.height = newStyle.height;
    videoHTMLContainer.style.backgroundColor = newStyle.backgroundColor;
    // set !important on position to eliminate the chance that clients
    // override this in their own CSS, causing layout issues.
    // we can't directly set the !important flag on position via the style object,
    // so add it by modifying the style on the textual (attribute) level
    videoHTMLContainer.style.setProperty('position', 'fixed', 'important');
};
export var setVideoContainerPlayoutRect = setPlayoutRect;

//# sourceMappingURL=set-playout-rect-utils.js.map